import { rem } from 'polished';
import styled from 'styled-components';
import { TrimTitleSectionStyled } from '../TrimTitleSectionStyled';

export const TrimTitleSectionStyledAC = styled(TrimTitleSectionStyled)`
    .title {
        font-size: ${rem(40)};
        color: ${({ theme }) => theme.colors.grey5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        text-transform: uppercase;
    }
`;
